import React, { useEffect } from 'react';
import './App.css';
import PaypalButton from './Paypal';
import { ApolloClient, ApolloProvider } from '@apollo/client';
import getApolloClient from './config/apolloClient';
import { LANDING_PAGE_URL } from './config/constants';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [client, setClient] = React.useState<ApolloClient<any> | null>(null);
  const params = new URLSearchParams(window.location.search);
  const bookingUuid = params.get('bookingUuid');
  const redirect = params.get('redirect');

  let locale = params.get('locale');

  // Convert to locale based language
  switch (locale) {
    case 'fr': {
      locale = 'fr_FR';
      break;
    }
    case 'es': {
      locale = 'es_ES';
      break;
    }
    default: {
      locale = 'en_US';
    }
  }

  useEffect(() => {
    const asyncSetClient = async () => {
      const c = await getApolloClient();
      setClient(c);
    };
    asyncSetClient();
  }, []);

  if (!client) {
    return <div>Loading...</div>;
  }

  // If the required query params are not present, redirect to the landing page
  if (!bookingUuid || !redirect) {
    window.location.href = LANDING_PAGE_URL;
    return null;
  }

  return (
    <div className="App">
      <ApolloProvider client={client}>
        <PaypalButton
          bookingUuid={bookingUuid}
          redirect={redirect}
          locale={locale}
        />
      </ApolloProvider>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss={false}
        rtl={false}
      />
    </div>
  );
}

export default App;
